var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncreaseBrandVisibility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_7116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5986 52.2999V26.0553H42.7569V52.2999H39.4763V32.6165H29.6345V52.2999H26.354V39.1776H16.5122V52.2999H13.2317V45.7388H3.38993V52.2999H0V55.5805C0.512098 55.5805 56.9238 55.5805 55.9885 55.5805V52.2999H52.5986Z",
    fill: "#FFBD05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18366 32.7863C14.5466 32.7863 22.4997 32.1184 29.9308 28.9386C37.1647 25.8423 42.1913 20.1173 45.3069 15.4447L49.8721 17.5736L47.2483 0.419479L32.4233 9.43461L36.367 11.2751C29.881 21.5382 18.9421 28.3027 6.76489 29.4897L6.90749 32.7622L9.18366 32.7863Z",
    fill: "#461D7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_7116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseBrandVisibility);
export default __webpack_public_path__ + "static/media/increase_brand_visibility.155595e5ef5308852b58e95955b8c6f8.svg";
export { ForwardRef as ReactComponent };